<template>
	<footer class="container-footer">
		<div class="container-xl">
			<div class="row">
				<div class="col-sm-12 col-md-6 footer-logo">
					<img v-if="footerData.logo" :src="`${footerData.logo}`" alt=""
						:style="{ 'max-height': footerData.logoMaxHeight, 'max-width': footerData.logoMaxWidth }">
				</div>

				<div class="col-sm-12 col-md-6 footer-address">
					<div class="row">
						<div class="col-sm-12 col-md-6">
							<div class="row">
								<h3>Weiterführende Links</h3>
							</div>
							<template v-for="(footer, index) in footerData.footnote">
								<div class="row" v-if="index == 'homepage' && footer.value != ''" :key="index">
									<div class="col-12 contact-field">
										<a href=""><span>{{ footer.value }}</span></a>
									</div>
								</div>
							</template>
						</div>

						<div class="col-sm-12 col-md-6">
							<div class="row">
								<h3>Wir im Netz</h3>
							</div>
							<template v-for="(footer, index) in footerData.footnote">
								<div class="row" v-if="index == 'socialNetworks' && footer.values != ''" :key="index">

									<div class="col-12 contact-value">
										<div class="social-icon" v-if="footer.values.facebook">
											<a :href="footer.values.facebook" target="blank">Facebook
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z"
														fill="currentColor" />
													<path
														d="M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z"
														fill="currentColor" />
												</svg>
											</a>
										</div>

										<div class="social-icon" v-if="footer.values.instagram">
											<a :href="footer.values.instagram" target="blank">Instagram
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z"
														fill="currentColor" />
													<path
														d="M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z"
														fill="currentColor" />
												</svg>
											</a>
										</div>

										<div class="social-icon" v-if="footer.values.twitter">
											<a :href="footer.values.twitter" target="blank">Twitter
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z"
														fill="currentColor" />
													<path
														d="M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z"
														fill="currentColor" />
												</svg>
											</a>
										</div>

										<div class="social-icon" v-if="footer.values.youtube">
											<a :href="footer.values.youtube" target="blank">YouTube
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z"
														fill="currentColor" />
													<path
														d="M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z"
														fill="currentColor" />
												</svg>
											</a>
										</div>

										<div class="social-icon" v-if="footer.values.linkedin">
											<a :href="footer.values.linkedin" target="blank">LinkedIn
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z"
														fill="currentColor" />
													<path
														d="M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z"
														fill="currentColor" />
												</svg>
											</a>
										</div>

										<div class="social-icon" v-if="footer.values.xing">
											<a :href="footer.values.xing" target="blank">Xing
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z"
														fill="currentColor" />
													<path
														d="M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z"
														fill="currentColor" />
												</svg>
											</a>
										</div>

										<div class="social-icon" v-if="footer.values.googleplus">
											<a :href="footer.values.googleplus" target="blank">Google+
												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z"
														fill="currentColor" />
													<path
														d="M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z"
														fill="currentColor" />
												</svg>
											</a>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
				<div class="oo-logo-wrapper"><img class="oo-logo-footer" src="@/assets/img/oo-footer.png" alt=""></div>
			</div>
		</div>
	</footer>
</template>

<script>

export default {
	props: {
		footerData: {
			type: Object
		}
	},
	methods: {
		addProtocol() {
			const elements = document.querySelectorAll('.social-icon a');

			for (const element of elements) {
				let href = element.getAttribute('href');

				if (!href.startsWith('https://')) {
					if (href.startsWith('http://')) {
						href = href.replace('http://', 'https://');
					} else {
						href = 'https://' + href;
					}

					element.setAttribute('href', href);
				}
			}
		}
	},
	mounted() {
		this.addProtocol();
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/footerComponent.scss";
</style>